import axios from '@fs/zion-axios'

const BASE_FAMOUS_PATH = '/service/dmc/famous'

export function searchForPerson(params) {
  return axios.get(`${BASE_FAMOUS_PATH}/match-persons`, { params: { ...params } })
}

export function createPerson(personDto) {
  return axios.post(`${BASE_FAMOUS_PATH}/match-person`, personDto)
}

export function updatePerson(personDto) {
  return axios.put(`${BASE_FAMOUS_PATH}/match-persons/${personDto.id}`, personDto)
}

export function deletePerson(searchMatchId) {
  return axios.delete(`${BASE_FAMOUS_PATH}/match-persons/${searchMatchId}`)
}

export function getAllPersons(matchType) {
  return axios.get(`${BASE_FAMOUS_PATH}/match-persons/${matchType}/all`)
}

export function getCountries() {
  return axios.get(`${BASE_FAMOUS_PATH}/countries`)
}
